<div
    class="pill"
    [class.clickable]="clickable"
    [class.compact]="compact"
    [class.available]="connector | isAvailable"
    [class.faulted]="connector | isFaulted"
    [class.charging]="connector | isCharging"
    [class.preparing]="connector | isPreparing"
    [class.finishing]="connector | isFinishing"
    [class.self-test]="connector | isSelfTest"
    [class.reserved]="connector | isReserved"
>
    {{ connector?.evseName || connector?.evseId || globalSearchConnector?.evseName || globalSearchConnector?.evseId }}
</div>
